<template>
  <div>
    <v-card>
      <v-card-title>Transmitir Guia a DHL</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="12" md="12">
            <v-combobox
              v-model="cuenta"
              :items="cuentas"
              item-text="nombre"
              item-value="cuenta"
              label="Cuenta"
              append-icon="check_circle"
              return-object
              :disabled="disableAll"
            ></v-combobox>
            <div v-if="cuenta">{{ cuenta.cuenta }}</div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="12">
            <v-checkbox
              v-model="enviarDatosCliente"
              label="Deseo transmitir los datos del cliente para la creación de la guia en DHL"
              :disabled="disableAll"
              @change="handleEnviarDatosChange()"
            ></v-checkbox>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="12">
            <v-combobox
              v-model="empresa"
              :items="empresas"
              item-text="empresa"
              item-value="id"
              label="Empresa"
              append-icon="mdi-office-building"
              return-object
              :disabled="disableAll"
              v-show="!enviarDatosCliente"
              clearable
            ></v-combobox>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="12">
            <v-checkbox
              v-model="generarFacturaComercial"
              label="Deseo generar la factura comercial en los servidores de DHL"
              :disabled="disableAll"
            ></v-checkbox>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer><v-btn :disabled="disableAll" outlined color="primary" @click="enviarDHL()"> Enviar a DHL </v-btn>
      </v-card-actions>
    </v-card>
    <v-overlay :value="overlay">
        <waiting />
    </v-overlay>
  </div>
</template>

<script>
import apicon from '../plugins/apicon';
import Waiting from '../components/Waiting.vue';
export default {
  props: {
      id : {
      type: Number,
      default: null,
    },
  },
  components:{
    Waiting
  },
  created: function () {},
  data() {
    return {
      cuentas: [],
      cuenta: null,
      empresas: [],
      empresa: null,
      enviarDatosCliente: true,
      generarFacturaComercial: false,
      overlay: false,
      disableAll: false,
    };
  },
  methods: {
    fillCuentas: function () {
      apicon.getDataApi(apicon.getApiBaseUrl() + 'cuentasdhl').then((result) => {
        this.cuentas = result;
      });
    },
    fillEmpresas: function() {
      apicon.getDataApi(apicon.getApiBaseUrl() + 'empresa').then((result) => {
        this.empresas = result;
      });
    },
    //Enviar guia a DHL
    enviarDHL: async function(){
        if(this.cuenta != null){
          if(!this.enviarDatosCliente && this.empresa == null){
            this.$swal("Por favor seleccione una empresa");
          }else{
            this.overlay = true;
            const validacion = await apicon.getDataApi(apicon.getApiBaseUrl() + 'dhladdressvalidate/' + this.id);
            if (!validacion.status) {
                this.overlay = false;
                this.$swal(validacion.message);
                return;
            }
            let id_empresa = this.empresa != null? this.empresa.id : 0;
            await apicon.saveDataApi(apicon.getApiBaseUrl() + 'enviardhl',  {
                id: this.id,
                cuenta : this.cuenta.cuenta,
                datosCliente : this.enviarDatosCliente,
                factura : this.generarFacturaComercial,
                id_empresa : id_empresa})
              .then((result) => {
                console.log(result);
                this.overlay = false;
                if (result.shipmentTrackingNumber) {
                    this.disableAll = true;
                    this.$swal("Se ha transmitido la información exitosamente su número de guía es : " + result.shipmentTrackingNumber);
                }else if (result.detail){
                    const addDetail = result.additionalDetails ? result.additionalDetails : '';
                    this.$swal("DHL ha notificado el siguiente error : " + result.detail + '\n' + addDetail);
                }
            });
          }
        }else{
            this.$swal("Por favor seleccione una cuenta para realizar el envío...");
        }
    },
    handleEnviarDatosChange: function(){
      if(!this.enviarDatosCliente){
        this.empresa = null;
      }
    },
  },
  mounted: function () {
    apicon.setAuthHeaders();
    this.fillCuentas();
    this.fillEmpresas();
  },
};
</script>
